import { Component, Inject } from '@angular/core'
import { Permision } from '../../../models/group.interface'
import { Profile } from '../../../models/users.interface'
import { GroupService } from '../../../services/group/group.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { AngularDualListBoxModule } from 'angular-dual-listbox'
import { MatIcon } from '@angular/material/icon'
import { dualListSettings } from '../../../../main'

@Component({
    selector: 'app-permisions',
    standalone: true,
    imports: [AngularDualListBoxModule, MatIcon],
    templateUrl: './permisions.component.html',
    styleUrl: './permisions.component.css',
})
export class PermisionsComponent {
    permisions: Permision[] = []
    profile: Profile | null = null
    firtsReder = true
    selected: Permision[] = []
    format = dualListSettings

    constructor(
        private groupService: GroupService,
        private dialogRef: MatDialogRef<PermisionsComponent>,
        @Inject(MAT_DIALOG_DATA) data: { profile: Profile }
    ) {
        this.profile = data.profile
    }

    ngOnInit(): void {
        this.fetchPermisions()
        if (this.profile) {
            this.selected = [...this.profile.permisions]
        }
    }

    private fetchPermisions() {
        if (this.profile) {
            this.groupService
                .getAllPermisions(true)
                .subscribe((permisions) => (this.permisions = permisions))
        }
    }

    closeDialog() {
        this.dialogRef.close()
    }

    saveChanges() {
        if (this.selected.length > 0 && this.profile) {
            this.groupService
                .assignUserPermision(this.selected, this.profile)
                .subscribe(() => this.closeDialog())
        }
    }
}
